import { Button } from '@kontentino/ui';
import { modalRoutes } from 'constants/routes';
import { ModalRouteProps } from 'context/ModalRouter';
import { FC } from 'react';
import CelebrationModalBase from 'app/components/modals/shared/CelebrationModalBase';
import FIRST_POST_APPROVED_ILLUSTRATION from './icon/first-post-approved.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Props = ModalRouteProps;

const FirstPostApprovedModal: FC<Props> = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <CelebrationModalBase
      modalManager={props.modalManager}
      dataName="first-post-approved-modal"
      dataCy="first-post-approved-modal"
      image={
        <div className="tw-flex tw-justify-center md:tw-min-w-[287px]">
          <img src={FIRST_POST_APPROVED_ILLUSTRATION} alt="Post approved" />
        </div>
      }
      title={t('firstPostApprovedModal.title', {
        defaultValue: `Abracadabra! Post Approved. 🙌`,
      })}
      description={t('firstPostApprovedModal.description', {
        defaultValue:
          "You've successfully cast the spell on tedious workflows! Want to get everyone collaborating and approving this smoothly? Expand the magic across your entire team.",
      })}
      button={
        <Button
          className="tw-w-full"
          onClick={() => navigate({ hash: modalRoutes.INVITE_USER })}
          variant="primary"
          size="large"
          data-name="first-post-approved_invite-team-button"
          data-cy="first-post-approved_invite-team-button"
        >
          {t('inviteYourTeamCta', {
            defaultValue: 'Invite your team',
          })}
        </Button>
      }
    />
  );
};

export default FirstPostApprovedModal;
